export class CenterLanguage {

    private internalId: string;
    private isoCode: string;
    private languageImage: string;
    private languageName: string;
    private locale: string;
    private phonePrefix: string;
    private supportedLanguage: string;

    constructor(internalId?: string, isoCode?: string, languageImage?: string, languageName?: string, locale?: string, phonePrefix?: string, supportedLanguage?: string) {
        this.internalId = internalId;
        this.isoCode = isoCode;
        this.languageImage = languageImage;
        this.languageName = languageName;
        this.locale = locale;
        this.phonePrefix = phonePrefix;
        this.supportedLanguage = supportedLanguage;
    }

    public get InternalId() {
        return this.internalId;
    }
    public get IsoCode() {
        return this.isoCode;
    }
    public get LanguageImage() {
        return this.languageImage;
    }
    public get LanguageName() {
        return this.languageName;
    }
    public get Locale() {
        return this.locale;
    }
    public get PhonePrefix() {
        return this.phonePrefix;
    }
    public get SupportedLanguage() {
        return this.supportedLanguage;
    }
    public set InternalId(internalId) {
        this.internalId = internalId;
    }
    public set IsoCode(isoCode) {
        this.isoCode = isoCode;
    }
    public set LanguageImage(languageImage) {
        this.languageImage = languageImage;
    }
    public set LanguageName(languageName) {
        this.languageName = languageName;
    }
    public set Locale(locale) {
        this.locale = locale;
    }
    public set PhonePrefix(phonePrefix) {
        this.phonePrefix = phonePrefix;
    }
    public set SupportedLanguage(supportedLanguage) {
        this.supportedLanguage = supportedLanguage;
    }
}
